"use strict";
function _typeof(t) {
    return (_typeof =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                  return typeof t;
              }
            : function (t) {
                  return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
              })(t);
}
function _classCallCheck(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t, e) {
    for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(t, _toPropertyKey(i.key), i);
    }
}
function _createClass(t, e, n) {
    return e && _defineProperties(t.prototype, e), n && _defineProperties(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function _toPropertyKey(t) {
    var e = _toPrimitive(t, "string");
    return "symbol" === _typeof(e) ? e : String(e);
}
function _toPrimitive(t, e) {
    if ("object" !== _typeof(t) || null === t) return t;
    var n = t[Symbol.toPrimitive];
    if (void 0 !== n) {
        var i = n.call(t, e || "default");
        if ("object" !== _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
}
var sideCart = (function () {
    function t(e) {
        _classCallCheck(this, t);
        (this.defaults = Object.assign(
            {},
            {
                sidecart: ".sidecart",
                sidecartWrapper: ".sidecart__wrapper",
                sidecartContent: ".sidecart__content",
                toggleButton: ".sidecart__toggle",
                itemQuantity: ".sidecart__qty--field",
                itemQuantityButton: ".sidecart__qty--button",
                itemQuantityPlus: ".sidecart__qty--plus",
                itemQuantityMinus: ".sidecart__qty--minus",
                itemRemove: ".sidecart__item-remove",
                itemQuickAddButtons: ".btn__quickadd",
                checkoutButton: ".sidecart__checkout-button",
                noteDialogTrigger: ".sidecart__note-trigger",
                noteDialog: ".sidecart__note",
            },
            e
        )),
            (this.sidecart = document.querySelector(this.defaults.sidecart)),
            (this.toggleButton = document.querySelector(this.defaults.toggleButton)),
            (this.sidecartWrapper = document.querySelector(this.defaults.sidecartWrapper)),
            (this.sidecartContent = document.querySelector(this.defaults.sidecartContent)),
            (this.itemQuantity = this.defaults.itemQuantity),
            (this.itemQuantityButton = this.defaults.itemQuantityButton),
            (this.itemQuantityPlus = this.defaults.itemQuantityPlus),
            (this.itemQuantityMinus = this.defaults.itemQuantityMinus),
            (this.itemRemove = this.defaults.itemRemove),
            (this.itemQuickAddButtons = this.defaults.itemQuickAddButtons),
            (this.checkoutButton = this.defaults.checkoutButton),
            (this.noteDialog = document.querySelector(this.defaults.noteDialog)),
            (this.noteDialogTrigger = document.querySelector(this.defaults.noteDialogTrigger)),
            this.init();
    }
    return (
        _createClass(t, [
            {
                key: "init",
                value: function () {
                    var t = this;
                    this.fetchCart(),
                        document.addEventListener(
                            "click",
                            function (e) {
                              if ((e.target.matches(t.defaults.toggleButton) && (e.preventDefault(), t.toggleCart()), e.target.matches(t.defaults.itemQuickAddButtons))) {
                                  e.preventDefault();
                                  var n = e.target.dataset.variant;
                                  t.quickAdd({ variant: n });
                              }
                              if (e.target.matches(t.defaults.noteDialogTrigger)) {
                                  e.preventDefault();
                                  var i = "true" == t.noteDialog.getAttribute("aria-hidden");
                                  t.sidecartWrapper.setAttribute("aria-hidden", i), t.noteDialog.setAttribute("aria-hidden", !i);
                              }
                              e.target.matches(t.defaults.itemQuickAddButtons) && (e.preventDefault(), t.saveNote());
                              
                            },
                            !1
                        );
                },
            },
            {
                key: "renderItem",
                value: function (t, e) {
                  // debugger;
                    var n = "",
                        i = "";
                    if (t.discounted_price < t.price) {
                        return (
                            null != _typeof(t.properties) &&
                                void 0 !== t.properties &&
                                void 0 !== t.properties._saved_ &&
                                void 0 !== t.properties._compare_ &&
                                // ((n = '<span class="compare-at-price">'.concat(t.properties._compare_, "</span>")), (i = '<strong class="discount-tag">'.concat(t.properties._saved_, "</strong>"))),
                                ((n = '<span class="compare-at-price">'.concat(t.properties._compare_, "</span>"))),
                            '\n\t\t\t<div class="sidecart__item">\n\t\t\t\t<a class="sidecart__item-image" href="'
                                .concat(t.url, '">\n\t\t\t\t\t<img alt="')
                                .concat(t.title, '" src="')
                                .concat(t.image, '"/>\n\t\t\t\t</a>\n\t\t\t\t<div class="sidecart__item-content">\n\t\t\t\t\t<div class="title-price-main"><p class="sidecart__item-title">')
                                .concat(t.product_title, "</p>\n\t\t\t\t\t")
                                .concat(null != t.variant_title ? '<p class="sidecart__item-variant">'.concat(t.variant_title, "</p>") : "", '\n\t\t\t\t\t<div class="custom-content">\n\t\t\t\t\t\t')
                                .concat(n, '\n\t\t\t\t\t\t<span class="sidecart__item-price slashed--price">$')
                                .concat(new Intl.NumberFormat("en-US").format(t.original_price / 100), "</span>\n\t\t\t\t\t\t")
                                // .concat(n, '\n\t\t\t\t\t\t<span class="sidecart__item-discount sidecart__item-price">')
                                // .concat('\n\t\t\t\t\t\t<span class="sidecart__item-discount sidecart__item-price">')
                                // .concat(Math.ceil(((t.original_price / 100 - t.discounted_price / 100) / (t.original_price / 100)) * 100))
                                // .concat("% OFF</span>\n\t\t\t\t\t\t")
                                .concat(n, '\n\t\t\t\t\t\t<span class="sidecart__item-price full---price">$')
                                .concat(new Intl.NumberFormat("en-US").format(Math.floor(t.discounted_price / 100)), "</span>\n\t\t\t\t\t\t")
                                .concat('\n\t\t\t\t\t\t<span class="sidecart__item-discount sidecart__item-price discount-tag">')
                                .concat(Math.round(((t.original_price / 100 - t.discounted_price / 100) / (t.original_price / 100)) * 100))
                                .concat("% OFF</span>\n\t\t\t\t\t\t")
                                .concat(
                                    i,
                                    '\t\t\t\t\t\n\t\t\t\t\t</div></div>\n\t\t\t\t\t<div class="sidecart__item-controls">\n\t\t\t\t\t\t<div class="sidecart__item-quantity">\n\t\t\t\t\t\t\t<button type="button" class="sidecart__qty--button sidecart__qty--minus" data-line="'
                                )
                                .concat(e + 1, '" aria-label="Reduce item quantity by one">-</button>\n\t\t\t\t\t\t\t<input type="text" name="updates[]" class="sidecart__qty--field" value="')
                                .concat(t.quantity, '" min="0" data-line="')
                                .concat(e + 1, '" aria-label="quantity" pattern="[0-9]*">\n\t\t\t\t\t\t\t<button type="button" class="sidecart__qty--button sidecart__qty--plus" data-line="')
                                .concat(e + 1, '" aria-label="Increase item quantity by one">+</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<a href="/cart/change?quantity=0&line=')
                                .concat(e + 1, '" class="sidecart__item-remove Link--underline" data-quantity="0" data-line="')
                                .concat(e + 1, '">Remove</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t')
                        );
                    } else {
                        return (
                            null != _typeof(t.properties) &&
                                void 0 !== t.properties &&
                                void 0 !== t.properties._saved_ &&
                                void 0 !== t.properties._compare_ &&
                                ((n = '<span class="compare-at-price">'.concat(t.properties._compare_, "</span>")), (i = '<strong class="discount-tag">'.concat(t.properties._saved_, "</strong>"))),
                            '\n\t\t\t<div class="sidecart__item">\n\t\t\t\t<a class="sidecart__item-image" href="'
                                .concat(t.url, '">\n\t\t\t\t\t<img alt="')
                                .concat(t.title, '" src="')
                                .concat(t.image, '"/>\n\t\t\t\t</a>\n\t\t\t\t<div class="sidecart__item-content">\n\t\t\t\t\t<div class="title-price-main"><p class="sidecart__item-title">')
                                .concat(t.product_title, "</p>\n\t\t\t\t\t")
                                .concat(null != t.variant_title ? '<p class="sidecart__item-variant">'.concat(t.variant_title, "</p>") : "", '\n\t\t\t\t\t<div class="custom-content"><div class="drawer-price-main">\n\t\t\t\t\t\t')
                                .concat(n, '\n\t\t\t\t\t\t<span class="sidecart__item-price">$')
                                .concat(new Intl.NumberFormat("en-US").format(t.price / 100), "</span></div>\n\t\t\t\t\t\t")
                                .concat(
                                    i,
                                    '\t\t\t\t\t\n\t\t\t\t\t</div></div>\n\t\t\t\t\t<div class="sidecart__item-controls">\n\t\t\t\t\t\t<div class="sidecart__item-quantity">\n\t\t\t\t\t\t\t<button type="button" class="sidecart__qty--button sidecart__qty--minus" data-line="'
                                )
                                .concat(e + 1, '" aria-label="Reduce item quantity by one">-</button>\n\t\t\t\t\t\t\t<input type="text" name="updates[]" class="sidecart__qty--field" value="')
                                .concat(t.quantity, '" min="0" data-line="')
                                .concat(e + 1, '" aria-label="quantity" pattern="[0-9]*">\n\t\t\t\t\t\t\t<button type="button" class="sidecart__qty--button sidecart__qty--plus" data-line="')
                                .concat(e + 1, '" aria-label="Increase item quantity by one">+</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<a href="/cart/change?quantity=0&line=')
                                .concat(e + 1, '" class="sidecart__item-remove Link--underline" data-quantity="0" data-line="')
                                .concat(e + 1, '">Remove</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t')
                        );
                    }
                },
            },
            {
                key: "fetchCart",
                value: function (t) {
                    var e = this;
                    window
                        .fetch("/cart.js", { credentials: "same-origin", method: "GET" })
                        .then(function (t) {
                            return t.json();
                        })
                        .then(function (n) {
                            (e.sidecartContent.innerHTML = ""),
                                n.items.forEach(function (t, n) {
                                    e.sidecartContent.innerHTML += e.renderItem(t, n);
                                })
                                console.log("n --->", n);
                                if(n.total_discount > 0){
                                  let all_sidecart_subtotal = document.querySelector('.Cart__Checkout').querySelectorAll('.sidecart-drawer__subtotal-price.slashed--price');
                                  
                                  let original_total_price = "$".concat(new Intl.NumberFormat("en-US").format(n.original_total_price / 100));
                                  let all_original_price = document.querySelectorAll('.sidecart-drawer__subtotal-price');

                                  // document.querySelector('.sidecart__footer').querySelector('.Cart__Discount').style.display = "block";

                                  // if()
                                  
                                  if(all_original_price.length > 0 && all_sidecart_subtotal.length > 0){
                                     document.querySelector('.Cart__Checkout').querySelector('.sidecart-drawer__subtotal-price').style.display = "block";
                                    all_original_price.forEach((original_price)=>{
                                      original_price.innerHTML = original_total_price;
                                    })
                                  }
                                  else{
                                    console.log("else");
                                    let sidecart_subtotal_html = `<span class="sidecart-drawer__subtotal-price slashed--price">${original_total_price}</span>`;
                                    let fragment = document.createRange().createContextualFragment(sidecart_subtotal_html);
                                    document.querySelector('.Cart__Checkout').appendChild(fragment);
                                  }
                                }
                                else{
                                  if(document.querySelector('.Cart__Checkout').querySelector('.sidecart-drawer__subtotal-price.slashed--price')){
                                    document.querySelector('.Cart__Checkout').querySelector('.sidecart-drawer__subtotal-price.slashed--price').style.display = "none";
                                  }
                                  // document.querySelector('.sidecart__footer').querySelector('.Cart__Discount').style.display = "none";
                                }
                                document.querySelectorAll("[data-sidecart-subtotal]").forEach(function (t) {
                                    t.innerHTML = "$".concat(new Intl.NumberFormat("en-US").format(n.total_price / 100));
                                }),
                                document.querySelectorAll("[data-sidecart-items]").forEach(function (t) {
                                    t.innerHTML = n.item_count;
                                }),
                                document.querySelectorAll(e.itemQuantity).forEach(function (t, n) {
                                    t.addEventListener("change", function (t) {
                                        e.changeItemQuantity(t.target.dataset.line, t.target.value);
                                    });
                                }),
                                document.querySelectorAll(e.itemRemove).forEach(function (t, n) {
                                    t.addEventListener("click", function (t) {
                                        t.preventDefault(), e.changeItemQuantity(t.target.dataset.line, 0);
                                    });
                                }),
                                document.querySelectorAll(e.itemQuantityButton).forEach(function (t, n) {
                                    t.addEventListener("click", function (t) {
                                        var n = t.target.parentNode.querySelector("input"),
                                            i = n.dataset.line,
                                            a = parseInt(n.value);
                                        "+" == t.target.innerHTML ? (a += 1) : a <= 0 ? (a = 0) : (a -= 1), (n.value = a), e.changeItemQuantity(i, n.value);
                                    });
                                }),
                                t && t();

                          // Updating Upsell Items
                                setTimeout(()=>{
                                 fetch('/search')
                                .then(response => {
                                  return response.text()
                                })
                                .then(data => {
                                  let parser = new DOMParser();
                                  let htmlDoc = parser.parseFromString(data, 'text/html');
                                  let updated_sidecart = htmlDoc.querySelector('section.sidecart');
                                  let product_upsell_items = updated_sidecart.querySelector('.product-upsell-main').innerHTML;
                                  let product_upsell_bogo_items = updated_sidecart.querySelector('.product-upsell-main-bogo').innerHTML;
                                  document.querySelector('section.sidecart').querySelector('.product-upsell-main').innerHTML = product_upsell_items;
                                  document.querySelector('section.sidecart').querySelector('.product-upsell-main-bogo').innerHTML = product_upsell_bogo_items;
                  
                                  upsell_add_items();
                                })
                                
                              })
                        })
                        .catch(function (t) {
                            throw new Error(t);
                        });
                },
            },
            {
                key: "openCart",
                value: function () {
                    if (!document.querySelector("body").classList.contains("sidecart-enabled--open")) {
                        // Store the current focused element
                        this.lastFocusedElement = document.activeElement;
                        
                        // Make sidecart interactive
                        this.sidecart.removeAttribute('aria-hidden');
                        this.sidecart.removeAttribute('inert');
                        
                        document.querySelector("body").classList.add("sidecart-enabled--open");
                        
                        // Focus the sidecart
                        this.sidecart.focus();
                        
                        // Add keyboard event listener
                        this.handleKeyboardEvents = this.handleKeyboardEvents.bind(this);
                        this.sidecart.addEventListener('keydown', this.handleKeyboardEvents);
                    }
                },
            },
            {
                key: "closeCart",
                value: function () {
                    document.querySelector("body").classList.remove("sidecart-enabled--open");
                    
                    // Make sidecart non-interactive
                    this.sidecart.setAttribute('aria-hidden', 'true');
                    this.sidecart.setAttribute('inert', '');
                    
                    // Remove keyboard event listener
                    this.sidecart.removeEventListener('keydown', this.handleKeyboardEvents);
                    
                    // Return focus to the last focused element
                    if (this.lastFocusedElement) {
                        this.lastFocusedElement.focus();
                    }
                },
            },
            {
                key: "toggleCart",
                value: function () {
                    if (document.querySelector("body").classList.contains("sidecart-enabled--open")) {
                        this.closeCart();
                    } else {
                        this.openCart();
                    }
                },
            },
            {
                key: "fetchAndOpenCart",
                value: function () {
                    var t = this;
                    this.fetchCart(function () {
                        return t.openCart();
                    });
                },
            },
            {
                key: "changeItemQuantity",
                value: function (t, e) {
                    var n = this;
                    window
                        .fetch("/cart/change.js", { method: "POST", credentials: "same-origin", body: JSON.stringify({ quantity: e, line: t }), headers: { "Content-Type": "application/json" } })
                        .then(function (t) {
                            return t.json();
                        })
                        .then(function () {
                            return n.fetchCart();
                        })
                        .catch(function (t) {
                            throw new Error(t);
                        });
                },
            },
            {
                key: "quickAdd",
                value: function (t) {
                    var e = this,
                        n = Object.assign(
                            {
                                qty: 1,
                                properties: {},
                                callback: function () {
                                    e.fetchAndOpenCart();
                                },
                            },
                            t
                        ),
                        i = n.items,
                        a = n.variant,
                        r = n.qty,
                        o = n.properties,
                        c = n.callback,
                        s = i ? { items: i } : { id: a, quantity: r, properties: o };
                    window
                        .fetch("/cart/add.js", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(s) })
                        .then(function (t) {
                            return t.json();
                        })
                        .then(function () {
                            "function" == typeof c && c();
                        })
                        .catch(function (t) {
                            throw new Error(t);
                        });
                },
            },
            {
                key: "setCookie",
                value: function (t, e) {
                    document.cookie = t + "=" + e;
                },
            },
            {
                key: "getCookie",
                value: function (t) {
                    for (var e = t + "=", n = decodeURIComponent(document.cookie).split(";"), i = 0; i < n.length; i++) {
                        for (var a = n[i]; " " == a.charAt(0); ) a = a.substring(1);
                        if (0 == a.indexOf(e)) return a.substring(e.length, a.length);
                    }
                    return "";
                },
            },
            {
                key: "handleKeyboardEvents",
                value: function (e) {
                    if (e.key === 'Escape') {
                        this.closeCart();
                        return;
                    }
                    
                    if (e.key === 'Tab') {
                        // Get all focusable elements
                        const focusableElements = this.sidecart.querySelectorAll(
                            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                        );
                        const firstFocusableElement = focusableElements[0];
                        const lastFocusableElement = focusableElements[focusableElements.length - 1];

                        // If shift + tab and on first element, move to last
                        if (e.shiftKey && document.activeElement === firstFocusableElement) {
                            e.preventDefault();
                            lastFocusableElement.focus();
                        }
                        // If tab and on last element, move to first
                        else if (!e.shiftKey && document.activeElement === lastFocusableElement) {
                            e.preventDefault();
                            firstFocusableElement.focus();
                        }
                    }
                },
            },
        ]),
        t
    );
})();
